import { atom } from "recoil";

export const errorModalState = atom({
  key: "errorModal",
  default: { status: false, page:"", text: "" },
});
